import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient, apiErrorMessage } from '@/lib/api'
import type { SkillDetail } from '@/lib/types'

export default function NewSkillPage() {
  const [intent, setIntent] = useState('')
  const navigate = useNavigate()
  const qc = useQueryClient()

  const mut = useMutation({
    mutationFn: async (description: string) => {
      const r = await apiClient.post<SkillDetail>('/api/v1/skills', {
        intentDescription: description,
      })
      return r.data
    },
    onSuccess: (skill) => {
      qc.invalidateQueries({ queryKey: ['skills'] })
      navigate(`/skills/${skill.id}`)
    },
  })

  return (
    <div className="max-w-2xl space-y-4">
      <div>
        <h1 className="text-2xl font-semibold">New skill</h1>
        <p className="text-sm text-neutral-500">
          Describe what this skill should do. Claude will generate the structured contract.
        </p>
      </div>
      <form
        className="space-y-3"
        onSubmit={(e) => {
          e.preventDefault()
          if (intent.trim().length < 10) return
          mut.mutate(intent.trim())
        }}
      >
        <label className="block text-sm">
          Intent (10–2000 chars)
          <textarea
            required
            minLength={10}
            maxLength={2000}
            rows={8}
            value={intent}
            onChange={(e) => setIntent(e.target.value)}
            className="mt-1 w-full rounded border px-2 py-1.5 text-sm font-mono"
            placeholder="Review software licensing contracts for GDPR compliance issues. Flag clauses that conflict with EU data protection rules…"
          />
          <span className="mt-1 block text-xs text-neutral-500">{intent.length} / 2000</span>
        </label>
        {mut.error && (
          <p className="text-sm text-red-600">{apiErrorMessage(mut.error)}</p>
        )}
        <button
          type="submit"
          disabled={mut.isPending || intent.trim().length < 10}
          className="rounded bg-neutral-900 text-white text-sm px-4 py-2 disabled:opacity-50"
        >
          {mut.isPending ? 'Analyzing with Claude…' : 'Create skill'}
        </button>
      </form>
    </div>
  )
}
